import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
import "../assets/scss/custom-bootstrap.scss";
import "../assets/scss/main.scss";

import { BSkeleton } from 'bootstrap-vue'
Vue.component('b-skeleton', BSkeleton)

Vue.use(BootstrapVue);
